<app-notification></app-notification>
<app-loader></app-loader>
<!-- Loader sur les resolve -->
<div id="app" class="position-relative">
  <div id="mask" *ngIf="isLoading$ | async">
    <div id="spinner" class="spinner-border text-info" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  
  <router-outlet></router-outlet>
  <span class="app-version">V {{ version }}</span>
</div>